module.exports = __webpack_public_path__ + "img/暂无参赛者报名@2x.3b03ffe2.png";